import { Component, computed, ElementRef, inject, Input, OnDestroy, signal, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
// @ts-expect-error No tiene el tipado requerido port TypeScripn
import google from '@google/maps';

import { GraficasService } from '../../../../../service/api/graficas.service';
import moment from 'moment';
import { TratamientoManezModel } from 'src/app/models/tratamientos/tratatamiento-manez.model';
import { GraficaData, GraficaManez } from '../../trata-manez/grafica-manez.interface';
import { TronicTelemetryInterface } from './tronic-telemetry.interface';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { NavigationService } from 'src/app/service/navigation.service';
import { UIChart } from 'primeng/chart';

declare let google: any;
interface ControlMaquinarias {
	fecha: string;
	date: string;
	id: string;
	id_cliente: string;
	id_maquinaria: string;
	id_usuario: string;
	imei: string;
	observaciones: string;
	ratio_ha: string;
	uds_medida: string;
	maquinaria?: { imei?: string };
	id_telemetry?: string;
}

interface AverageData {
	averageFlow: number;
	averagePressure: number;
	averageVel: number;
	averageDose: number;
	averageRpm: number;
}
@Component({
	selector: 'app-dialog-tratamiento-manez',
	standalone: false,
	templateUrl: './dialog-tratamiento-manez.component.html',
	styleUrls: ['./dialog-tratamiento-manez.component.scss'],
	providers: [MessageService],
})
export class dialogTratamientoManezLozanoChartsComponent implements OnDestroy {
	navigationService = inject(NavigationService);

	@Input() graficacaudal = '';

	@Input() showGraficas = false;

	@ViewChild('gmap', { static: false }) gmapElement!: ElementRef;

	@ViewChild('chart') chart?: UIChart;

	optionsChart = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			zoom: {
				pan: {
					enabled: true,
					mode: 'xy',
				},
				zoom: {
					wheel: {
						enabled: true,
					},
					pinch: {
						enabled: true,
					},
					mode: 'x',
				},
			},
		},
	};

	tracksMyl = signal<TronicTelemetryInterface[]>([] as TronicTelemetryInterface[]);
	treatmentDataSets = signal<GraficaManez[]>([] as GraficaManez[]);
	treatmentCharts = signal<GraficaManez>({} as GraficaManez);
	treatmentOrigin = signal<TratamientoManezModel>({} as TratamientoManezModel);
	currentNumberChart = signal<number>(0);
	lengthDataSets = signal<number>(0);

	currentChart = computed<GraficaData | null>(() => {
		const datasets = this.treatmentDataSets();
		const index = this.currentNumberChart();

		if (index < 0 || index >= datasets.length) {
			return null;
		}

		const dataset = datasets[index] as GraficaManez;

		return {
			labels: [...(dataset.labels ?? [])],
			datasets: [
				{
					label: 'Velocidad',
					data: this.getDatasetData(dataset.vel, 2),
					fill: false,
					tension: 0.4,
				},
				{
					label: 'Caudal',
					data: this.getDatasetData(dataset.flow, 2),
					fill: false,
					tension: 0.4,
				},
				{
					label: 'Presión',
					data: this.getDatasetData(dataset.pressure, 2),
					fill: false,
					tension: 0.4,
				},
				{
					label: 'Dosis',
					data: this.getDatasetData(dataset.dose, 2),
					fill: false,
					tension: 0.4,
				},
				{
					label: 'Rpm',
					data: this.getDatasetData(dataset.rpm, 2),
					fill: false,
					tension: 0.4,
				},
			],
		};
	});

	averageData = computed<AverageData>(() => {
		const charts = this.treatmentDataSets();

		if (!charts.length) {
			return {
				averageFlow: 0,
				averagePressure: 0,
				averageVel: 0,
				averageDose: 0,
				averageRpm: 0,
			};
		}

		const flowValues = this.getAllValues((chart) => chart.flow);
		const pressureValues = this.getAllValues((chart) => chart.pressure);
		const velValues = this.getAllValues((chart) => chart.vel);
		const doseValues = this.getAllValues((chart) => chart.dose);
		const rpmValues = this.getAllValues((chart) => chart.rpm);

		return {
			averageFlow: this.getAverage(flowValues),
			averagePressure: this.getAverage(pressureValues),
			averageVel: this.getAverage(velValues),
			averageDose: this.getAverage(doseValues),
			averageRpm: this.getAverage(rpmValues),
		};
	});

	showDialog = false;
	showMap = true;
	intervaloRecorrido: string | number | NodeJS.Timeout | undefined;
	map: google.maps.Map = null;
	routeDraw: BaseResponseModel<TronicTelemetryInterface> = BaseResponseModel.error<TronicTelemetryInterface>('', 0);

	private readonly graficaService = inject(GraficasService);
	private readonly messageService = inject(MessageService);

	ngOnDestroy(): void {
		this.routeDraw = BaseResponseModel.error<TronicTelemetryInterface>('', 0);
		this.map = [];
	}

	opendialogChart(maq: ControlMaquinarias) {
		const data: TratamientoManezModel = {
			id: maq.id,
			fecha: maq.date,
			fecha_formatted: moment(maq.fecha).format('DD/MM/YYYY'),
			id_maquinaria: maq.id,
			id_usuario: maq.id_usuario,
			ratio_ha: +maq.ratio_ha,
			uds_medida: maq.uds_medida,
			maquinaria_nombre: maq.observaciones,
			campo_nombre: maq.observaciones,
			maquinaria: {
				id: maq.id,
				imei: maq.imei,
			},
		};

		this.treatmentOrigin.set(data);
		this.loadResumeTronic(data, true);
	}

	private getDatasetData(graph: GraficaData | undefined, decimales: number = 2): number[] {
		const datasets = graph?.datasets;

		if (!datasets) {
			return [];
		}

		const data = Array.isArray(datasets) ? datasets[0]?.data : datasets.data;

		if (!Array.isArray(data)) {
			return [];
		}

		return data.map((value: any) => {
			if (value == null || value === '') {
				return 0;
			}

			const numberValue = Number(value);

			if (!Number.isFinite(numberValue)) {
				return 0;
			}

			return Number(numberValue.toFixed(decimales));
		});
	}

	public loadResumeTronic(data: TratamientoManezModel, verbose = true): void {
		if (data.maquinaria?.imei == null || data.maquinaria?.imei.length === 0) {
			alert('Maquinaria sin imei asignado');
			return;
		}

		this.initializeMap();

		if (verbose) {
			this.graficaService.getDataCharts(data.maquinaria?.imei, data.fecha ?? '').subscribe({
				next: (response) => {
					const charts = Array.isArray(response) ? response : Object.values(response ?? {});

					if (charts.length > 0) {
						this.treatmentDataSets.set(charts as GraficaManez[]);
						this.lengthDataSets.set(charts.length);
						this.currentNumberChart.set(0);

						this.showDialog = true;

						setTimeout(() => {
							this.map = new google.maps.Map(this.gmapElement.nativeElement, {
								zoom: 10,
								zoomControl: true,
								zoomControlOptions: {
									position: google.maps.ControlPosition.RIGHT_TOP,
								},
								mapTypeId: google.maps.MapTypeId.HYBRID,
								mapTypeControlOptions: {
									mapTypeIds: ['roadmap', 'hybrid'],
									position: google.maps.ControlPosition.TOP_RIGHT,
									labels: true,
								},
								disableDefaultUI: false,
								fullscreenControl: false,
								streetViewControl: false,
								tilt: 0,
							});
						});

						this.graficaService.getTracksMyl(data.maquinaria?.imei ?? '', data.fecha ?? '').subscribe({
							next: (tracks) => {
								if (tracks.data) {
									this.tracksMyl.set(tracks.data);
									this.drawTracks();
								}
							},
							error: (e) => {
								console.warn('catch en graficaService: ' + e);
							},
						});
					} else {
						this.messageService.add({
							severity: 'warn',
							summary: 'Advertencia',
							detail: 'Registro sin resultados',
						});
					}
				},
				error: (e) => {
					console.warn('catch en graficaService: ' + e);
				},
			});
		}
	}

	nextChart(): void {
		const maxIndex = this.treatmentDataSets().length - 1;
		const currentIndex = this.currentNumberChart();

		if (currentIndex >= maxIndex) {
			return;
		}

		this.currentNumberChart.set(currentIndex + 1);

		queueMicrotask(() => {
			this.chart?.refresh();
		});
	}

	previousChart(): void {
		const currentIndex = this.currentNumberChart();

		if (currentIndex <= 0) {
			return;
		}

		this.currentNumberChart.set(currentIndex - 1);

		queueMicrotask(() => {
			this.chart?.refresh();
		});
	}

	deleteInterval(): void {
		this.showGraficas = false;
		clearInterval(this.intervaloRecorrido);
	}

	initializeMap(): void {
		this.map = [];

		window.scrollTo(0, 0);
		window.scrollBy(0, 0);
		window.scroll(0, 0);
	}

	// public scrollToTop() {
	// 	const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');
	// 	if (elements && elements[0]) {
	// 		setTimeout(() => {
	// 			if (elements[0]) {
	// 				elements[0].scrollTop = 0;
	// 			}
	// 		}, 100);
	// 	}
	// }

	private getAverage(values: number[]): number {
		if (!values.length) {
			return 0;
		}

		const total = values.reduce((sum, value) => sum + value, 0);

		return Number((total / values.length).toFixed(2));
	}

	private getAllValues(selector: (chart: GraficaManez) => GraficaData): number[] {
		return this.treatmentDataSets().flatMap((chart) => this.getDatasetData(selector(chart), 2));
	}

	selectedTrack = signal<TronicTelemetryInterface | null>(null);

	// private infowindow?: google.maps.InfoWindow;
	private routePolylines: google.maps.Polyline[] = [];

	public drawTracks(): void {
		if (!this.map) {
			return;
		}

		this.clearTracks();
		this.selectedTrack.set(null);

		let lastLatLng: google.maps.LatLng | null = null;

		this.tracksMyl().forEach((track: TronicTelemetryInterface) => {
			const currentLatLng = new google.maps.LatLng(track.lat, track.lon);

			if (!lastLatLng) {
				lastLatLng = currentLatLng;
			}

			const res = track.io & 15;

			const polyline = new google.maps.Polyline({
				path: [lastLatLng, currentLatLng],
				strokeColor: res === 0 ? 'yellow' : '#ff3333',
				geodesic: true,
				strokeOpacity: res === 0 ? 0.8 : 1,
				strokeWeight: 5,
			});

			polyline.setMap(this.map);
			this.routePolylines.push(polyline);

			google.maps.event.addListener(polyline, 'click', () => {
				this.selectedTrack.set(track);
			});

			google.maps.event.addListener(polyline, 'mouseover', () => {
				this.selectedTrack.set(track);
			});

			lastLatLng = currentLatLng;
		});

		if (lastLatLng) {
			this.map.setCenter(lastLatLng);
			this.map.setZoom(17);
		}
	}

	private clearTracks(): void {
		this.routePolylines.forEach((polyline) => {
			google.maps.event.clearInstanceListeners(polyline);
			polyline.setMap(null);
		});

		this.routePolylines = [];
	}
}
